import { fetcher } from "helpers/fetcher";

import { TSearchTrainStationReq, TSearchTrainStationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const searchTrainStations = async (payload?: TSearchTrainStationReq) => {
  return await fetcher<TSearchTrainStationRes, TSearchTrainStationReq["data"]>(
    ENDPOINT.CORPORATION.SEARCH_TRAIN_STATIONS,
    {
      params: payload?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.SEARCH_TRAIN_STATIONS.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const querySearchTrainStations = async (
  payload?: TSearchTrainStationReq
) => {
  return (await searchTrainStations(payload)).data;
};

querySearchTrainStations._key = (payload?: TSearchTrainStationReq) => [
  ENDPOINT.CORPORATION.SEARCH_TRAIN_STATIONS.url,
  payload,
];
